import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addArtistOfMonthAPI, fetchArtistOfMonthAPI } from '../services/api';

export const getArtistOfMonth = createAsyncThunk('monthArtist/getArtistOfMonth', async () => {
    const response = await fetchArtistOfMonthAPI(); // Pass reviewId if available
    return response.data;
});

// Send monthArtists with the selected template
export const addArtistOfMonth = createAsyncThunk(
    'monthArtist/addArtistOfMonth',
    async ({ user_id, month, year }, { rejectWithValue }) => {
        try {
            const response = await addArtistOfMonthAPI({
                user_id, month, year
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const artistOfMonth = createSlice({
    name: 'monthArtist',
    initialState: {
        monthArtist: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // Get monthArtists
            .addCase(getArtistOfMonth.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getArtistOfMonth.fulfilled, (state, action) => {
                state.monthArtist = action.payload.data;
                state.status = 'succeeded';
            })
            .addCase(getArtistOfMonth.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })

            // Get monthArtists
            .addCase(addArtistOfMonth.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addArtistOfMonth.fulfilled, (state, action) => {
                state.monthArtist = action.payload.data;
                state.status = 'succeeded';
            })
            .addCase(addArtistOfMonth.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
    },
});

export default artistOfMonth.reducer;